/** A length of time as the run surfaces show it: "45s", "12m 5s", "1h 05m".
 *
 * Shared so the upload pill, the run cards, the integrations queue and the
 * scheduled-run lists read the same shape for the same thing. */
export const formatDurationSeconds = (totalSeconds: number): string => {
  const s = Math.max(0, Math.floor(totalSeconds));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  const remS = s % 60;
  if (m < 60) return remS === 0 ? `${m}m` : `${m}m ${remS}s`;
  const h = Math.floor(m / 60);
  return `${h}h ${String(m % 60).padStart(2, "0")}m`;
};
